'use client'

import React from 'react'
import { ArrowRight } from 'lucide-react'

interface BlogEndCTAProps {
  heading: string
  links: {
    title: string
    href: string
    description: string
  }[]
}

export default function BlogEndCTA({ heading, links }: BlogEndCTAProps) {
  return (
    <div data-blog-layout='narrow'>
      <div
        data-cta-id='blog_end'
        className='my-8 p-6 md:p-8 bg-muted/50 rounded-2xl border border-border/60'
      >
        <h3 className='text-lg font-semibold text-foreground mb-4'>
          {heading}
        </h3>

        <div className='space-y-3'>
          {links.map((link, index) => (
            <a
              key={index}
              href={link.href}
              className='group flex items-start gap-3 p-3 rounded-xl bg-background border border-border/60 hover:border-[#008dcc]/30 transition-colors'
            >
              <div className='min-w-0 flex-1'>
                <span className='text-sm font-medium text-[#008dcc] group-hover:underline underline-offset-2'>
                  {link.title}
                </span>
                <p className='text-xs text-muted-foreground mt-0.5'>
                  {link.description}
                </p>
              </div>
              <ArrowRight className='w-4 h-4 text-muted-foreground group-hover:text-[#008dcc] flex-shrink-0 mt-0.5 transition-colors' />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
